import { render, staticRenderFns } from "./ReportCrops.vue?vue&type=template&id=fd44b026&scoped=true"
import script from "./ReportCrops.vue?vue&type=script&lang=js"
export * from "./ReportCrops.vue?vue&type=script&lang=js"
import style0 from "./ReportCrops.vue?vue&type=style&index=0&id=fd44b026&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd44b026",
  null
  
)

export default component.exports